import { motion } from 'framer-motion'

export default function PageHeader({
    eyebrow,
    title,
    lede
}: {
    eyebrow?: string
    title: string
    lede?: string
}) {
    return (
        <section
            className="relative overflow-hidden paper-grain"
            style={{
                borderTop: '1px solid var(--color-rule)',
                borderBottom: '1px solid var(--color-ink-700)'
            }}
        >
            <div className="container-prose py-9 md:py-12 text-center">
                {eyebrow && (
                    <motion.div
                        initial={{ opacity: 0, y: 8 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.45 }}
                        className="kicker kicker--center"
                    >
                        {eyebrow}
                    </motion.div>
                )}
                <motion.h1
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.55, delay: 0.05 }}
                    className="font-display mt-4"
                    style={{
                        fontSize: 'clamp(1.9rem, 4vw, 3rem)',
                        lineHeight: 1.04,
                        letterSpacing: '-0.025em',
                        color: 'var(--color-ink-700)'
                    }}
                >
                    {title}
                </motion.h1>

                <motion.hr
                    initial={{ opacity: 0, scaleX: 0 }}
                    animate={{ opacity: 1, scaleX: 1 }}
                    transition={{ duration: 0.6, delay: 0.15 }}
                    className="rule-accent mt-5 mx-auto"
                    style={{ width: '3.5rem', transformOrigin: 'center' }}
                />

                {lede && (
                    <motion.p
                        initial={{ opacity: 0, y: 12 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.55, delay: 0.2 }}
                        className="lede mt-5 mx-auto"
                        style={{ maxWidth: '42rem', fontSize: '1.125rem' }}
                    >
                        {lede}
                    </motion.p>
                )}
            </div>
        </section>
    )
}
